<h1 mat-dialog-title>Disable exercise as Basic</h1>
<div mat-dialog-content>
  <p>You are attempting to disable BASIC property on this exercise but there <span *ngIf="data.count>1">are {{data.count}} basic Timelines</span><span *ngIf="data.count===1">is one Timeline</span> with it included. If you proceed, all related Timelines <strong>WILL BE DISABLED AS BASIC</strong> too.</p>  
</div>
<div mat-dialog-actions fxLayoutAlign="space-between stretch">
  <button mat-button [mat-dialog-close]>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, proceed</button>
</div>